export enum ctaList {
	PRIVATE = 'Private Label Available',
	CLEAN_LABEL = 'Clean Label & Vegan',
	NEXTY = 'NEXTY Finalists',
	NEW_TO_MARKET = 'New To Market',
	MINORTITY_OWNED = 'Minority-Owned Snacks',
	KEHE = 'Available in KeHe'
}
